import DoubleQuotes from './DoubleQuotes';

export default DoubleQuotes;
